export const kebab2camel = k =>
  k[0].toUpperCase() + k.slice(1).replace(/-([a-z])/g, g => g[1].toUpperCase());
